import React, { useCallback, useState } from 'react';
import { Typography, TypographyProps } from './Typography';
import { CubeAnchorLink } from './CubeAnchorLink';
import { decodeHtml } from '@cube3/common/utils/decodeHtml';

interface TextTrimmerProps extends TypographyProps {
  maxLength?: number;
  fullText: string;
}
/** A component for trimming long text, allowing switching between full text and trimmed text */
export const TextTrimmer = (props: TextTrimmerProps) => {
  const { fullText, maxLength, ...restProps } = props;
  const [showAll, setShowAll] = useState(false);

  const shouldTrim = maxLength && fullText && fullText.length > maxLength;
  const trimmed = shouldTrim ? fullText.substring(0, maxLength) : fullText;

  const toggle = useCallback(() => setShowAll((prev) => !prev), []);

  if (!shouldTrim)
    return <Typography {...restProps}>{decodeHtml(fullText)}</Typography>;

  return (
    <>
      {decodeHtml(showAll ? fullText : trimmed)}
      <CubeAnchorLink href={undefined} onLinkClick={toggle}>
        {' '}
        …{showAll ? 'Show less' : 'Show more'}
      </CubeAnchorLink>
    </>
  );
};
